import { styled, keyframes } from "@mui/material/styles";
import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/material";

// Keyframes

export const pulseScale = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.14); }
`;

export const floatUp = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
`;

export const dotBounce = keyframes`
  0%, 55%, 100% { transform: translateY(0); opacity: 0.25; }
  25% { transform: translateY(-10px); opacity: 1; }
`;

export const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

// Styled components with animations

export const AnimatedIconContainer = styled(Box)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 88,
    height: 88,
    animation: `${floatUp} 1.8s ease-in-out infinite`
});

export const PulsingIconWrapper = styled(Box)({
    borderRadius: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    zIndex: 1,
    animation: `${pulseScale} 0.9s ease-in-out infinite`
});

export const LoadingDot = styled(Box)<{ delay?: string }>(({ delay = "0s" }) => ({
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #F31779, #7930D9)",
    animation: `${dotBounce} 0.85s ease-in-out infinite`,
    animationDelay: delay
}));

// Static sx styles
const styles: Record<string, SxProps<Theme>> = {
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: "40px 24px",
        gap: "28px"
    },
    textBlock: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        textAlign: "center"
    },
    headlineText: {
        background: "linear-gradient(120deg, #F31779 0%, #7930D9 45%, #25C0E6 100%)",
        backgroundSize: "200% auto",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontSize: "20px",
        fontWeight: 700,
        lineHeight: "28px",
        animation: `${shimmer} 1.8s linear infinite`
    },
    subtitleText: {
        fontSize: "13px",
        lineHeight: "20px",
        color: "greyscale.500",
        maxWidth: 260
    },
    dotsRow: {
        display: "flex",
        alignItems: "center",
        gap: "8px"
    }
};

export default styles;
